import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  transform(number: string): any {
    if (!number) {
      return '';
    }

    const phoneNumber = number.replace(/\D/g, '');

    switch (phoneNumber.length) {
      case 11:
        const intlCode = phoneNumber.slice(0, 1);
        return `+${intlCode} ${this.sliceBaseNumber(phoneNumber.slice(1))}`;
      case 10:
        return this.sliceBaseNumber(phoneNumber);
      default:
        return '';
    }
  }

  sliceBaseNumber(phoneNumber): string {
    const areaCode = phoneNumber.slice(0, 3);
    const firstThree = phoneNumber.slice(3, 6);
    const lastFour = phoneNumber.slice(6);

    return `(${areaCode}) ${firstThree}-${lastFour}`;
  }
}
